import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteAdvertisementAvatarsService = async (
  advertisementId: string,
): Promise<void> => {
  await cjPontanegraApi.delete(`/avatars/announcements/${advertisementId}`);
};
